exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.category-header {\n    border-bottom: 1px solid black;\n    margin-top: 17px;\n    margin-bottom: 25px !important\n}\n", ""]);

// exports
